/* src/app/components/participant-leads-list/participant-leads-list.component.css */
.ref-head-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.create-button {
  padding: 4px 5px;
}
.button-sec {
  margin-bottom: 8px;
}
.main {
  width: 96%;
  margin: auto;
}
h2 {
  font-size: 1.286rem;
}
.action {
  display: flex;
  flex-direction: row;
  font-size: 1rem;
  font-style: italic;
  font-weight: 700;
  color: darkslategrey;
}
.table-style {
  width: 100%;
}

/* src/app/components/payroll/authorizations/spending-plans-list/spending-plans-list.component.css */
:host {
  --sp-brand: #00504B;
  --sp-brand-tint: #e8f1f0;
  --sp-border: #d9e0e0;
  --sp-border-strong: #9fb5b3;
  --sp-muted: #6b7a7a;
  --sp-row-hover: #f4f8f8;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}
.plans-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}
.plans-search {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 320px;
}
.plans-search .fa-search {
  position: absolute;
  left: 10px;
  color: var(--sp-muted);
  font-size: 0.85rem;
}
.plans-search-input {
  width: 100%;
  padding: 6px 10px 6px 30px;
  border: 1px solid var(--sp-border-strong);
  border-radius: 4px;
  font-size: 0.9rem;
}
.plans-search-input:focus-visible {
  outline: var(--focus-outline, 3px solid rgba(0, 0, 255, 1));
  outline-offset: 1px;
}
.plans-toolbar-actions {
  display: flex;
  gap: 14px;
}
.link-button {
  background: none;
  border: none;
  padding: 0;
  color: var(--sp-brand);
  font-size: 0.85rem;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}
.link-button:focus-visible {
  outline: var(--focus-outline, 3px solid rgba(0, 0, 255, 1));
  outline-offset: 2px;
}
.plans-scroll {
  width: 100%;
  overflow-x: auto;
}
.plans-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
  background: #fff;
}
.plans-table > thead > tr > th {
  background: var(--sp-brand);
  color: #fff;
  font-weight: 600;
  text-align: center;
  padding: 8px 10px;
  white-space: nowrap;
  border-right: 1px solid rgba(255, 255, 255, 0.18);
}
.plans-table > tbody > tr > td {
  padding: 8px 10px;
  border-bottom: 1px solid var(--sp-border);
  text-align: center;
  vertical-align: middle;
}
.plan-row {
  cursor: pointer;
}
.plan-row:hover {
  background: var(--sp-row-hover);
}
.plan-row.expanded {
  background: var(--sp-brand-tint);
  font-weight: 600;
}
.col-toggle {
  width: 36px;
  text-align: center;
}
.toggle-button {
  background: none;
  border: none;
  padding: 4px 6px;
  cursor: pointer;
  color: var(--sp-brand);
}
.toggle-button:focus-visible {
  outline: var(--focus-outline, 3px solid rgba(0, 0, 255, 1));
  outline-offset: 1px;
}
.strong {
  font-weight: 700;
}
.num {
  text-align: center;
}
.nowrap {
  white-space: nowrap;
}
.muted {
  color: var(--sp-muted);
  font-style: italic;
}
.empty-message {
  text-align: center;
  padding: 24px;
  color: var(--sp-muted);
}
:host ::ng-deep .plans-paginator {
  background-color: #fff;
  border-top: 1px solid var(--sp-border);
  padding: 12px 0 4px;
  margin-top: 12px;
  justify-content: end;
}
:host ::ng-deep .plans-paginator .p-paginator-current {
  color: var(--sp-brand);
  font-weight: 500;
}
:host ::ng-deep .plans-paginator .p-paginator-page {
  background-color: #fff;
  border: 1px solid #d0d8d6;
  color: var(--sp-brand);
  margin: 0 2px;
  border-radius: 4px;
  transition: all 0.2s ease;
  min-width: 2rem;
  height: 2rem;
}
:host ::ng-deep .plans-paginator .p-paginator-page:not([data-p-active=true]):hover {
  background-color: #f9fffe;
  border-color: #00a99d;
  color: #00704a;
}
:host ::ng-deep .plans-paginator .p-paginator-page[data-p-active=true],
:host ::ng-deep .plans-paginator .p-paginator-page.p-highlight {
  background-color: #00a99d !important;
  border-color: #00a99d !important;
  color: #fff !important;
  font-weight: 600 !important;
}
:host ::ng-deep .plans-paginator .p-paginator-first,
:host ::ng-deep .plans-paginator .p-paginator-prev,
:host ::ng-deep .plans-paginator .p-paginator-next,
:host ::ng-deep .plans-paginator .p-paginator-last {
  background-color: #f9fffe !important;
  border: 1px solid #d0d8d6 !important;
  color: var(--sp-brand) !important;
  border-radius: 4px !important;
  transition: all 0.2s ease !important;
}
:host ::ng-deep .plans-paginator .p-paginator-first:not(.p-disabled):hover,
:host ::ng-deep .plans-paginator .p-paginator-prev:not(.p-disabled):hover,
:host ::ng-deep .plans-paginator .p-paginator-next:not(.p-disabled):hover,
:host ::ng-deep .plans-paginator .p-paginator-last:not(.p-disabled):hover {
  background-color: #00a99d !important;
  border-color: #00a99d !important;
  color: #fff !important;
}
:host ::ng-deep .plans-paginator .p-paginator-rpp-options {
  background-color: #fff;
  border: 1px solid #d0d8d6;
  border-radius: 4px;
}
.detail-message {
  margin: 0;
  padding: 12px 4px;
  color: var(--sp-muted);
  font-size: 0.82rem;
}
.detail-row > td {
  padding: 0 !important;
  background: var(--sp-brand-tint);
  border-bottom: 2px solid var(--sp-border-strong);
}
.detail-wrapper {
  padding: 10px 12px 14px 40px;
  overflow-x: auto;
}
.detail-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  font-size: 0.82rem;
  border: 1px solid var(--sp-border-strong);
}
.detail-table th {
  text-align: center;
  padding: 6px 8px;
  white-space: nowrap;
  border-bottom: 1px solid var(--sp-border-strong);
}
.detail-table .group-header th {
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 0.72rem;
  color: var(--sp-brand);
  padding: 5px 8px;
}
.detail-table .group-auth {
  background: #dbeae8;
}
.detail-table .group-provider {
  background: #e9f0e4;
}
.detail-table .group-service {
  background: #f2ecdd;
}
.detail-table thead tr:last-child th {
  background: #f6f8f8;
  font-weight: 600;
  color: #33403f;
}
.detail-table td {
  padding: 6px 8px;
  border-bottom: 1px solid var(--sp-border);
  text-align: left;
  vertical-align: top;
}
.group-provider-start,
.group-service-start {
  border-left: 2px solid var(--sp-border-strong) !important;
}
.detail-table td.span-cell {
  background: #fbfdfd;
  vertical-align: middle;
}
.detail-table tbody tr.auth-start > td {
  border-top: 2px solid var(--sp-border-strong);
}
.detail-table tbody tr.allocation-end > td:not(.span-cell) {
  border-bottom: 2px solid var(--sp-border-strong);
}
.cell-primary {
  font-weight: 600;
  color: #1f2d2c;
}
.cell-secondary {
  color: #4a5a59;
  margin-top: 2px;
}
.cell-meta {
  color: var(--sp-muted);
  font-size: 0.75rem;
  margin-top: 2px;
}
.cell-meta.warn {
  color: #a33a2a;
  font-weight: 600;
}
.span-cell .link-button {
  margin-top: 6px;
  font-size: 0.78rem;
}
.chip {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 6px;
  border-radius: 8px;
  background: #fdf1dc;
  color: #8a5b12;
  font-size: 0.7rem;
  font-weight: 600;
}
/*# sourceMappingURL=spending-plans-list.component-4CUMH333.css.map */
